/**
 * UnexpectedAPIResponseFormatError
 * Used when the API fails a basic schema check
 */
export default class UnexpectedAPIResponseFormatError extends Error {
  
  // TODO: this is duck-typing, because babel is broken
  static type = "UnexpectedAPIResponseFormatError";
  
  constructor(response) {
    super("Response data is not in the correct format.");
    this.response = response;
    this.type = UnexpectedAPIResponseFormatError.type;
  }
  
}



// WEBPACK FOOTER //
// ./src/lib/appserver/responseExceptions/UnexpectedAPIResponseFormatError.js